import _ from 'lodash';

export enum BadgeClaimType {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3',
}

export enum TransmissionStatusType {
    SUBMITTED = 'SUBMITTED',
    ACKNOWLEDGED = 'ACKNOWLEDGED',
    ADJUDICATED = 'ADJUDICATED',
    COMPLETED = 'COMPLETED',
    REJECTED = 'REJECTED',
    DENIED = 'DENIED',
    FORWARDED = 'FORWARDED',
    WARNING = 'WARNING',
}

export const assembleName = (first?: string, last?: string, suffix?: string): string => {
    return _.compact([suffix, first, last]).join(' ');
};

export const generateLabel = (prefix: string, id?: string, name?: string) => {
    if (name) {
        return `${prefix}: ${name}`;
    } else if (id) {
        return `${prefix} ID – ${truncateUuid(id)}`;
    } else {
        return prefix;
    }
};

/**
 * Append an NPI to a badge label: `Rendering Provider: Aditya Vora · NPI 1730561428`.
 *
 * **Absent NPI drops the segment entirely — it never renders a placeholder.**
 * A chip reading `· NPI —` says the National Provider Identifier is missing, and on a
 * claims console that is a claim about the submission, not about this screen: an
 * 837 without a rendering NPI is rejected by the payer. "We were not given it to
 * display" and "it is not on the claim" are different facts and must not look the
 * same (NS-3).
 *
 * Deliberately NOT folded into `generateLabel`, which nine badges share — Claim,
 * Guarantor, Patient, Payer, Seller and Subscriber have no NPI, and widening a
 * symbol with 26 upstream dependents to serve two of them is how a shared helper
 * turns into a grab bag.
 */
export const withNpi = (label: string, npi?: string): string => (npi ? `${label} \u00b7 NPI ${npi}` : label);

export const truncateUuid = (uuid: string): string => _.split(uuid, '-')[0];
